const validate = values => {
  const errors = {}

  if (values && values.add_contacts?.contacts) {
    values.add_contacts?.contacts.forEach((contact, index) => {
      if (!contact?.contact.name) {
        errors.add_contacts = {
          ...errors.add_contacts,
          contacts: {
            ...errors.add_contacts?.contacts,
            [`${index}`]: {
              ...errors.add_contacts?.contacts[`${index}`],
              contact: {
                ...errors.add_contacts?.contacts[`${index}`]?.contact,
                name: "The name is required!",
              },
            },
          },
        }
      }
      if (contact?.contact?.is_email_displayed && !contact?.contact?.email) {
        errors.add_contacts = {
          ...errors.add_contacts,
          contacts: {
            ...errors.add_contacts?.contacts,
            [`${index}`]: {
              ...errors.add_contacts?.contacts[`${index}`],
              contact: {
                ...errors.add_contacts?.contacts[`${index}`]?.contact,
                email: "The email is required!",
              },
            },
          },
        }
      }

      if (contact?.contact?.is_phone_displayed && !contact?.contact?.phone) {
        errors.add_contacts = {
          ...errors.add_contacts,
          contacts: {
            ...errors.add_contacts?.contacts,
            [`${index}`]: {
              ...errors.add_contacts?.contacts[`${index}`],
              contact: {
                ...errors.add_contacts?.contacts[`${index}`]?.contact,
                phone: "The phone is required!",
              },
            },
          },
        }
      }

      if (
        contact?.contact?.phone &&
        !/^(\+)?(\d{1,4})?[( .-]*(\d{1,4})[) .-]*(\d{1,4})[ .-]*(\d{1,4})[ .-]*(\d{1,4})?$/.test(
          contact?.contact?.phone
        )
      ) {
        errors.add_contacts = {
          ...errors.add_contacts,
          contacts: {
            ...errors.add_contacts?.contacts,
            [`${index}`]: {
              ...errors.add_contacts?.contacts[`${index}`],
              contact: {
                ...errors.add_contacts?.contacts[`${index}`]?.contact,
                phone: "Invalid phone number!",
              },
            },
          },
        }
      }
    })
  }

  return errors
}

export default validate
